(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var initialiseRelatedProductsTracking = function(productRecommendationsSection) {
  if (!productRecommendationsSection || typeof gtag !== 'function') { return; }

  var listName = productRecommendationsSection.dataset.gaListName || 'You May Also Like';
  var listId = productRecommendationsSection.dataset.gaListId || 'pdp_ymal';
  var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : window.ga4Config && window.ga4Config.currency;
  var trackedItems = new WeakSet();

  var getItem = function(element) {
    return {
      item_id: element.dataset.gaItemId,
      item_name: element.dataset.gaItemName,
      item_brand: element.dataset.gaItemBrand,
      price: Number(element.dataset.gaItemPrice),
      item_variant: element.dataset.gaItemVariant,
      index: Number(element.dataset.gaItemIndex)
    };
  };

  var reportView = function(element) {
    if (trackedItems.has(element)) { return; }
    trackedItems.add(element);
    gtag('event', 'view_item_list', {
      currency: currency,
      item_list_name: listName,
      item_list_id: listId,
      items: [getItem(element)],
      transport_type: 'beacon'
    });
  };

  var items = productRecommendationsSection.querySelectorAll('[data-ga-item-id]');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) { return; }
        reportView(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.5 });
    items.forEach(function(item) { observer.observe(item); });
  } else {
    items.forEach(reportView);
  }

  if (productRecommendationsSection.dataset.gaClickTrackingReady === 'true') { return; }
  productRecommendationsSection.dataset.gaClickTrackingReady = 'true';
  productRecommendationsSection.addEventListener('click', function(event) {
    var link = event.target.closest('.product-link');
    if (!link || !productRecommendationsSection.contains(link)) { return; }

    var item = link.closest('[data-ga-item-id]');
    if (!item) { return; }

    gtag('event', 'select_item', {
      currency: currency,
      item_list_name: listName,
      item_list_id: listId,
      items: [getItem(item)],
      transport_type: 'beacon'
    });
  });
};

var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
      initialiseRelatedProductsTracking(productRecommendationsSection);
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
